/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import AutoComplete from '../BaseComponent/autocomplete'

class ProviderPlans extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      list: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',

      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerid',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'دارای برنامه تامین',
          value: 'productsWithPlan',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'بدون برنامه تامین',
          value: 'productsWithoutPlan',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کاربر مسئول',
          value: 'operatorId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'ویرایش',
          value: '',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: '',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      providerId: '',
      operators: [],
      operatorId: ''
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  get componentDidMount() {
    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].providerId
            result[i]['label'] = 'شناسه :' + result[i].providerId + '-' + result[i].title
          }

          this.setState({
            providers: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    this.getReport(false)
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            errorForm: '',
            lengthList: response.data.object.countAll,
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeProvider = (selectedOption) => {
    this.setState({selectedOption})
  }

  changeProviderId = (operatorId) => {
    this.setState({operatorId})
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let providerId = this.state.providerId
    let operatorId = this.state.operatorId == null || this.state.operatorId == '' ? '' : this.state.operatorId.personId
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (operatorId !== '') {
      filter.operatorId = operatorId
    }

    return filter
  }

  filter() {
    this.getReport(false)
  }

  changeDropDown(data) {
    this.setState({
      listWareHouse: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)

    http
      .get(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        }
      })
  }

  deleteItem = (id) => {
    if (window.confirm('آیا از حذف این ایتم مطمپن هستید؟؟')) {
      http.delete(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}/${id}`, {}).then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت حذف شد')
          this.getReport(false)
        }
      })
    }
  }

  render() {
    let {pageNumber, pageSize} = this.state
    let name = cookie.load('name')
    let columns = ['ردیف', 'تامین کننده', 'برنامه تامین', 'بدون برنامه تامین', 'کاربر مسئول']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="اطلاعات پایه برنامه تامین کنندگان"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.providerName}</td>
                  <td>{item.productsWithPlan}</td>
                  <td>{item.productsWithoutPlan}</td>
                  <td>{item.operatorName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش کالاهای تکمیل شده رانندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver.name'}
                title={'راننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driver'}
                field={'productCount'}
                title={'کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driver'}
                field={'receivedCount'}
                title={'دریافت شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'operatorName'}
                field={'operatorName'}
                title={'کاربر مسئول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>برنامه تامین کنندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'plans/create'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.changeProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        isDisabled={false}
                                    /> */}
                </div>

                <div className="formComponent selectComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.changeProviderId}
                    lableText="کاربر مسئول"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.providerName}</td>
                      <td>{item.productsWithPlan}</td>
                      <td>{item.productsWithoutPlan}</td>
                      <td>{item.operatorName}</td>
                      <td>
                        <Link target="_blank" to={`plans/edit/${item.id}`}>
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.deleteItem(item.id)}>
                          <img src={require('../../image/trash.svg')} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProviderPlans
